import { useSnapshot } from '@/hooks/useSnapshot'
import { KuroBoardOverviewSchema } from '@/modules/kuroboard/schema'
import { kuroboardApi } from '@/modules/kuroboard/api'
import { DEFAULT_REFRESH_INTERVAL } from '@/lib/constants'

export function useKuroBoardOverview() {
  return useSnapshot(
    kuroboardApi.overview(),
    'kuroboard',
    'overview',
    KuroBoardOverviewSchema,
    DEFAULT_REFRESH_INTERVAL
  )
}
